import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "debug"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "debug__title" }, "Settings", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "aside__line debug__line" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "debug__title" }, "Other data:", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "aside__line debug__line" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "debug__title" }, "Modals:", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "aside__line debug__line" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "debug__title" }, "LoadingData:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "aside__line debug__line" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "debug__title" }, "UserData:", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_ripple = _resolveDirective("ripple")!

  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives((_openBlock(), _createElementBlock("button", {
          class: "btn btn-sm btn-tertiary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isVisible = !_ctx.isVisible))
        }, [
          _createTextVNode(" Hide ")
        ])), [
          [_directive_ripple]
        ]),
        _hoisted_2,
        _createElementVNode("p", null, "compactMode: " + _toDisplayString(_ctx.$store.state.settings.compactMode), 1),
        _hoisted_3,
        _hoisted_4,
        _createElementVNode("p", null, "isNavigationVisible: " + _toDisplayString(_ctx.$store.state.isNavigationVisible), 1),
        _createElementVNode("p", null, "isPopUpExists: " + _toDisplayString(_ctx.$store.state.isPopUpExists), 1),
        _hoisted_5,
        _hoisted_6,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.state.modal, (line, key) => {
          return (_openBlock(), _createElementBlock("p", { key: line }, _toDisplayString(key) + ": " + _toDisplayString(line), 1))
        }), 128)),
        _hoisted_7,
        _hoisted_8,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.state.loading, (line, key) => {
          return (_openBlock(), _createElementBlock("p", { key: line }, _toDisplayString(key) + ": " + _toDisplayString(line), 1))
        }), 128)),
        _hoisted_9,
        _hoisted_10,
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.state.user, (line, key) => {
          return (_openBlock(), _createElementBlock("p", { key: line }, _toDisplayString(key) + ": " + _toDisplayString(line), 1))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}